import { v4 } from "uuid";

const uuid = () => v4();

export default uuid;
